import { View, Text } from '@react-pdf/renderer';
import styles from '../styles/styles';

interface MetricsProps {
    labels: {
        volumeAndWeight: string;
        volumeRm?: string;
        volumeM3?: string;
        volumeProduced?: string;
        weightTon?: string;
        bark: string;
    };
    data: {
        volumeRm?: string;
        volumeM3?: string;
        volumeProduced?: string;
        weightTon?: string;
    };
}

const Metrics = ({ labels, data }: MetricsProps) => {
    return (
        <>
            <View style={styles.row}>
                <Text style={styles.subHeader}>{labels.volumeAndWeight}</Text>
            </View>

            <View style={styles.miniSpacer} />

            <View style={styles.row}>
                {/* Column 1: m3 */}
                <View style={styles.column}>
                    <Text style={styles.label}>{labels.volumeM3}:</Text>
                    <Text>{data.volumeM3}</Text>
                    <Text>{labels.bark}</Text>
                </View>

                {/* Column 2: rm */}
                <View style={styles.column}>
                    <Text style={styles.label}>{labels.volumeRm}:</Text>
                    <Text>{data.volumeRm}</Text>
                    <Text>{labels.bark}</Text>
                </View>

                {/* Column 3: produced */}
                {labels.volumeProduced && data.volumeProduced && (
                    <View style={styles.column}>
                        <Text style={styles.label}>{labels.volumeProduced}:</Text>
                        <Text>{data.volumeProduced}</Text>
                    </View>
                )}

                {/* Column 3: weight */}
                {data.weightTon && (
                    <View style={styles.column}>
                        <Text style={styles.label}>{labels.weightTon}:</Text>
                        <Text>{data.weightTon}</Text>
                        <Text>{labels.bark}</Text>
                    </View>
                )}

                {/* Empty cols for spacing */}
                <View style={styles.column} />
                <View style={styles.column} />
            </View>
        </>
    );
};

export default Metrics;